import {
  Box,
  Button,
  Container,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Text,
  VStack
} from "@chakra-ui/react"
import CallToAction from "../components/CallToAction"
import Footer from "../components/Footer"

const teamMembers = [
  {
    name: "Amandeep Kalra",
    role: "CEO",
    description:
      "Architect in residential property for over 10 years, including 5 with an award-winning developer. Non-Executive Director at a 14,000-home Housing Association with £95m+ ARR. Advisor to the Mayor of London on sustainability and innovation; member of the Design Council Homes Taskforce.",
    image: "/images/team-amandeep.png",
    linkedin: "https://www.linkedin.com/in/amandeep-kalra-a1914ba4/"
  },
  {
    name: "Thomas Quiroga",
    role: "CTO",
    description:
      "15+ years in software and product management, startup-focused. Co-founder of Rooser ($30M+ raised). Built and scaled a CTO-as-a-Service agency. Property investor who has completed a full home retrofit from assessment to installation.",
    image: "/images/team-thomas.png",
    linkedin: "https://www.linkedin.com/in/thomasquiroga/"
  },
  {
    name: "Rachel McVeagh",
    role: "Founder's Associate",
    description:
      "8 years taking complex B2B software products to market across global markets. Led commercial strategy, revenue operations, and deal negotiation across a $400M portfolio.",
    image: "/images/team-rachel.png",
    linkedin: "https://www.linkedin.com/in/mcveagh/"
  },
  {
    name: "Sam Watts",
    role: "ML Engineer",
    description:
      "Predictive modelling, geospatial data, and computer vision. Led production ML systems across climate-critical infrastructure, retail, and health, including recommender systems delivering £1m+ annual value.",
    image: "/images/team-sam.png",
    linkedin: "https://www.linkedin.com/in/swatts123/"
  }
]

const Team: React.FC = () => {
  return (
    <Box>
      <Container maxW="container.lg" py={24}>
        <Heading
          as="h1"
          size="5xl"
          color="brand.700"
          mb={16}
          textAlign="center"
          style={{ textWrap: "balance" } as React.CSSProperties}
        >
          The team
        </Heading>

        <SimpleGrid columns={{ base: 1, sm: 2 }} gap={16}>
          {teamMembers.map((member) => (
            <VStack key={member.name} gap={4} align="center" textAlign="center">
              {/* Photo with gray fallback bg so broken images show a circle, not a broken icon */}
              <Box
                boxSize="160px"
                borderRadius="full"
                bg="gray.200"
                overflow="hidden"
                flexShrink={0}
              >
                <Image
                  src={member.image}
                  boxSize="160px"
                  borderRadius="full"
                  alt={member.name}
                  objectFit="cover"
                />
              </Box>

              <Box>
                <Heading as="h3" size="xl" color="brand.700">
                  {member.name}
                </Heading>
                <Text
                  fontWeight="semibold"
                  color="brand.600"
                  fontSize="md"
                  mt={1}
                >
                  {member.role}
                </Text>
              </Box>

              <Text
                fontSize="sm"
                color="gray.700"
                lineHeight="tall"
                maxW="38ch"
                style={{ textWrap: "pretty" } as React.CSSProperties}
              >
                {member.description}
              </Text>

              <Link
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`View ${member.name} on LinkedIn`}
              >
                <Button
                  size="sm"
                  variant="outline"
                  borderColor="brand.600"
                  color="brand.600"
                  _hover={{
                    bg: "gray.50",
                    borderColor: "brand.700",
                    color: "brand.700"
                  }}
                >
                  View on LinkedIn
                </Button>
              </Link>
            </VStack>
          ))}
        </SimpleGrid>
      </Container>

      <CallToAction />
      <Footer />
    </Box>
  )
}

export default Team
